export const URL = '/api/statistic'
